export class PressureConverter {
	static toImperial(precipitation: number): number {
		return (precipitation / 6.89475729);
	}

	static toMetric(precipitation: number): number {
		return (precipitation * 6.89475729);
	}
}